import Model from "~/models/_Model";

export default class Scannable extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/scanning";
  }

  // Set the resource route of the model
  resource() {
    return "scannable";
  }

  relations() {
    return {};
  }

  get display_picture_url() {
    if (this.picture_url) {
      return (
        this.picture_url.replace("//mylhs", "//app-mylhs") +
        "?appId=scanning_station"
      );
    }
    return "/person.jpg";
  }
}
